import React from "react";
import { Button } from "@shopify/polaris";
const Layout = (props) => {
  const connectIntegration = (crispEvent) => {
    if (typeof window.$crisp != undefined && window.$crisp != undefined) {
      window.$crisp.push(["set", "session:event", ["Synctrack" + crispEvent]]);
    }
  };
  return (
    <div style={{ marginTop: "20px" }} className="integration-layout">
      <div className="logo text-center">
        <img alt={props.title} src={props.logo} />
      </div>
      <div className="title text-center mt-3">{props.title}</div>
      <div className="description text-center mt-2">{props.description}</div>
      <div className="cta text-center mt-4">
        <Button primary onClick={() => connectIntegration(props.crispEvent)}>
          Connect Now
        </Button>
      </div>
    </div>
  );
};

export default Layout;
